// App utils
import { datajs, datajsAll } from '../shared/utils';
import { Modal } from 'bootstrap';

export default class LangSelect {
	static init() {
		const toggleSiteHeaderLangBtn = datajs('site-header-lang-toggle');
		const langSelectInputs = datajsAll('lang-select-input');
		const langSelectElement = datajs('lang-select');
		let langSelectModal = false;

		const showLangSelect = () => {
			toggleSiteHeaderLangBtn.setAttribute('aria-expanded', 'true');
			document.body.classList.add('has-langSelect');
			langSelectModal.show();
			return false;
		};

		const changeLanguage = (input) => {
			const url = input.value;

			// Don't do anything if the url is empty
			if (!url) {
				return false;
			}

			// Hide the modal
			langSelectModal.hide();

			// Update the url if the user selected a different language
			if (typeof input.dataset.isCurrentLanguage === 'undefined') {
				setTimeout(() => {
					window.location.href = url;
				}, 300);
			}
		};

		// Setup the modal and toggle button
		if (langSelectElement && toggleSiteHeaderLangBtn) {
			langSelectModal = new Modal(langSelectElement);

			langSelectElement.addEventListener('hide.bs.modal', function () {
				toggleSiteHeaderLangBtn.setAttribute('aria-expanded', 'false');
				document.body.classList.remove('has-langSelect');
			});

			toggleSiteHeaderLangBtn.addEventListener('click', showLangSelect);
		}

		// Handle language selection
		if (langSelectInputs) {
			langSelectInputs.forEach((item) => {
				item.addEventListener('keydown', (e) => {
					// Enter press
					if (e.keyCode === 13) {
						changeLanguage(e.target);
					}
				});

				item.addEventListener('click', (e) => {
					// "True" Click event
					if (e.type === 'click' && e.clientX !== 0 && e.clientY !== 0) {
						changeLanguage(e.target);
					}
				});
			});
		}
	}
}
